import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";

export function ShiftCodeDeleteDialog({
  open,
  isPending,
  onOpenChange,
  onConfirm,
}: {
  readonly open: boolean;
  readonly isPending: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-[min(420px,calc(100vw-32px))] gap-0 rounded-[10px] border-0 bg-white p-0 font-pretendard shadow-lg"
        overlayClassName="bg-black/45"
      >
        <div className="px-10 pb-5 pt-8">
          <DialogTitle className="whitespace-pre-line text-center text-base font-medium text-foreground">
            정말로 이 근무코드를 삭제하시겠습니까?
          </DialogTitle>
        </div>
        <DialogFooter className="flex-row justify-center gap-2 px-10 pb-6 sm:justify-center sm:space-x-0">
          <Button
            type="button"
            variant="outline"
            disabled={isPending}
            className="rounded-full border-2 border-sig bg-transparent px-7 py-5 text-[15px] text-sig hover:border-sig/80 hover:text-sig/80"
            onClick={() => onOpenChange(false)}
          >
            아니오
          </Button>
          <Button
            type="button"
            disabled={isPending}
            className="rounded-full border-2 border-transparent bg-sig px-7 py-5 text-[15px] hover:bg-sig/90"
            onClick={onConfirm}
          >
            {isPending ? "삭제 중" : "예"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
